{
    "errorCode": "error",
    "errorMessage": "Oops ! Something went wrong",
    "successCode": "success",
    "labelPdfExtension": ".pdf",
    "defaultTcPdfName": "studentTc.pdf",
    "pdfDownloadIssue": "Issue In Downloading The PDF File",
    "zipDownloadIssue": "Issue In Downloading The ZIP File",
    "tcPreviewIssue": "Issue In Opening TC Preview",
    "pdfPrintIssue": "Issue In Printing The PDF File",
    "noTcPreviewAvailable": "No, TC Preview Available",
    "labelProceed": "Proceed",
    "labelCancel": "Cancel",
    "emailErrorMessage": "Please enter a valid email address.",
    "labelAdd": "+ Add",
    "labelEmailId": "Email ID",
    "labelEmailSharing": "Email Sharing",
    "noMatchedContentFound": "No Matched Student Name Is Found For Applied Search",
    "labelNewTcGenerated": "New TC Generated",
    "labelDuplicated": "Duplicated", 
    "labelDownload": "Download",
    "labelEmail": "Email"
}